/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class ShipTransactionTermsAndCondAgreementDTO extends JSONable {

  uuid: string | undefined = undefined;
  offerUuid: string | undefined = undefined;
  spOfferRequestUuid: string | undefined = undefined;
  template: string | undefined = undefined;
  leTermsAndConditionsAgreementUuid: string | undefined = undefined;
  comments: string | undefined = undefined;
  amendment: string | undefined = undefined;
  status: string | undefined = undefined;
  seen: boolean | undefined = undefined;
}
